import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { Languages, LOCALSTORAGE_LANGUAGE_KEY } from './constants';
const getInitConfig = ({ backendLoadPath, additionalResources, interpolationVariables, }) => ({
    react: {
        useSuspense: false,
    },
    backend: backendLoadPath
        ? {
            loadPath: backendLoadPath,
        }
        : undefined,
    returnNull: false,
    supportedLngs: Object.values(Languages),
    fallbackLng: Languages.Ru,
    debug: false,
    detection: {
        order: ['queryString', 'cookie', 'navigator'],
        caches: ['cookie'],
        lookupCookie: 'lang',
        lookupLocalStorage: LOCALSTORAGE_LANGUAGE_KEY,
    },
    interpolation: {
        escapeValue: false,
        defaultVariables: Object.assign({ nbsp: '\u00A0', mdash: '\u2014' }, (interpolationVariables || {})),
    },
    partialBundledLanguages: true,
    resources: Object.assign({ cimode: {
            translation: {},
        } }, (additionalResources || {})),
});
export const i18nConfig = ({ initReactI18next, backendLoadPath, additionalResources, interpolationVariables, }) => {
    if (backendLoadPath) {
        return i18next
            .use(Backend)
            .use(LanguageDetector)
            .use(initReactI18next)
            .init(getInitConfig({ backendLoadPath, additionalResources, interpolationVariables }));
    }
    return i18next
        .use(LanguageDetector)
        .use(initReactI18next)
        .init(getInitConfig({ backendLoadPath, additionalResources, interpolationVariables }));
};
